// src/shared/adapters/HttpClient.ts

import { AxiosInstance, AxiosRequestConfig } from 'axios';
// import { useLoadingStore } from '../stores/loadingStore';

export class HttpClient {
  constructor(private client: AxiosInstance) {}

  async get<T>(
    url: string,
    params?: Record<string, any>,
    config: AxiosRequestConfig = {},
    showGlobalLoading = true,
  ): Promise<T> {
    if (showGlobalLoading) {
      // useLoadingStore.getState().incrementRequests();
    }

    try {
      const mergedConfig: AxiosRequestConfig = {
        ...config,
        params,
      };

      const response = await this.client.get(url, mergedConfig);
      return response.data;
    } finally {
      if (showGlobalLoading) {
        // useLoadingStore.getState().decrementRequests();
      }
    }
  }

  /** JSON mutations whose public errors are handled by their consumer, without logging response content. */
  async postJson<T>(url: string, data?: unknown, config: AxiosRequestConfig = {}): Promise<T> {
    const response = await this.client.post<T>(url, data, config);
    return response.data;
  }

  async post<T>(url: string, data?: any, showGlobalLoading = true, config?: AxiosRequestConfig): Promise<T> {
    if (showGlobalLoading) {
      // useLoadingStore.getState().incrementRequests();
    }

    try {
      let finalConfig = config;
      // TODO: FIXME - ESTE BLOQUE DEBE SER REMOVIDO CUANDO TODOS LOS ENDPOINTS MIGREN A postMultipart/postForm
      // El código original de Edu (commit 4d630bb3) detecta FormData para eliminar Content-Type.
      // Endpoints afectados: ProfileApiAdapter, ProductDimensionsApiAdapter, ClientsApiAdapter
      // Solución: migrar esos 3 endpoints a postMultipart y eliminar este bloque.
      if (data instanceof FormData) {
        finalConfig = {
          ...config,
          headers: {
            ...(config?.headers as Record<string, unknown>),
            'Content-Type': false,
          },
        };
      }

      const response = await this.client.post(url, data, finalConfig);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('POST Error:', {
          message: error.message,
          status: error.response.status,
          data: error.response.data,
        });
      }
      throw error;
    } finally {
      if (showGlobalLoading) {
        // useLoadingStore.getState().decrementRequests();
      }
    }
  }

  /**
   * POST con multipart/form-data — usa axios.postForm para enviar FormData.
   */
  async postMultipart<T>(url: string, formData: FormData, config: AxiosRequestConfig = {}): Promise<T> {
    const response = await this.client.postForm(url, formData, config);
    return response.data;
  }

  async put<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.client.put(url, data, config);
    // Manejar 204 No Content: cuando el status es 204, response.data puede ser undefined/null
    // Para métodos que retornan void, esto es correcto. Para otros casos, retornar data si existe.
    if (response.status === 204) {
      // 204 No Content es un éxito válido, retornar undefined para métodos void
      return undefined as T;
    }
    return response.data;
  }

  async patch<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.client.patch(url, data, config);
    return response.data;
  }

  async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.client.delete(url, config);
    if (response.status === 204) {
      return undefined as T;
    }
    return response.data;
  }
}

// Factory para crear instancia con apiClientWH u otro
export const createHttpClient = (axiosInstance: AxiosInstance): HttpClient => {
  return new HttpClient(axiosInstance);
};
